module.exports = __webpack_public_path__ + "img/3.b6c22888.png";